import type { SessionContextItem } from './SessionContext';

/** Shared defensive check so an ineligible item cannot leave an empty metadata slot. */
export const isLinkableSessionContext = (
	context: SessionContextItem,
): context is SessionContextItem & { url: string } => {
	if (!context.label.trim() || !context.url?.trim()) {
		return false;
	}

	try {
		const url = new URL(context.url);
		return url.protocol === 'https:' || url.protocol === 'http:';
	} catch {
		return false;
	}
};
